import { createStyles, makeStyles, Theme, withStyles } from '@material-ui/core';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        list: {
            width: '100%',
            maxWidth: 360,
        },
        button: {
            marginLeft: theme.spacing(1),
            marginBotton: theme.spacing(1),
        },
    }),
);

export const Accordion = withStyles({
    root: {
        backgroundColor: '#fff',
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    expanded: {},
})(MuiAccordion);

export const AccordionSummary = withStyles({
    root: {
        marginBottom: -1,
        minHeight: 50,
        '&$expanded': {},
    },
    content: {
        '&$expanded': {
            margin: '12px 0',
        },
    },
    expanded: {},
})(MuiAccordionSummary);

export const AccordionDetails = withStyles(theme => ({
    root: {
        padding: theme.spacing(2),
        backgroundColor: 'rgba(0, 0, 0, 0.03)',
    },
}))(MuiAccordionDetails);
